import React from 'react';
import type { EdgePreviewT, PendingNodeT, TemplateEdgeT, TemplateNodeT } from '../../../../labelling-v2/types/skeleton-template-builder.type';
import { CanvasEdges } from './canvas-edges';
import { CanvasNodes } from './canvas-nodes';
import { CanvasPreviewLayer } from './canvas-preview-layer';
type CanvasSvgLayerPropsT = {
  data: {
    nodes: TemplateNodeT[];
    edges: TemplateEdgeT[];
    nodeMap: Map<string, TemplateNodeT>;
  };
  preview: {
    pendingNode: PendingNodeT | null;
    edgePreview: EdgePreviewT | null;
  };
  selection: {
    hoveredNodeId: string | null;
    selectedNodeId: string | null;
  };
  handlers: {
    onNodeSelect: (nodeId: string) => void;
    onNodeHoverChange: (nodeId: string | null) => void;
  };
  strokeColor: string;
};
const svgStyles = {
  position: ('absolute' as const),
  inset: 0
};
export function CanvasSvgLayer({
  data,
  preview,
  selection,
  handlers,
  strokeColor
}: CanvasSvgLayerPropsT) {
  return <svg width="100%" height="100%" style={svgStyles}>
      <CanvasEdges edges={data.edges} nodeMap={data.nodeMap} strokeColor={strokeColor} />

      <CanvasPreviewLayer edgePreview={preview.edgePreview} pendingNode={preview.pendingNode} nodeMap={data.nodeMap} color={strokeColor} />

      <CanvasNodes nodes={data.nodes} hoveredNodeId={selection.hoveredNodeId} selectedNodeId={selection.selectedNodeId} onSelect={handlers.onNodeSelect} onHoverChange={handlers.onNodeHoverChange} />
    </svg>;
}